import { usePage } from '@inertiajs/react'
import type { SharedProps } from '@/types'
import { CheckCircleIcon, AlertCircleIcon, XIcon } from 'lucide-react'
import { useState, useEffect } from 'react'
import { cn } from '@/lib/utils'

export function FlashMessages() {
  const { flash } = usePage<SharedProps>().props
  const [visible, setVisible] = useState({ notice: false, alert: false })

  useEffect(() => {
    if (flash.notice) setVisible((v) => ({ ...v, notice: true }))
    if (flash.alert) setVisible((v) => ({ ...v, alert: true }))
  }, [flash.notice, flash.alert])

  if (!visible.notice && !visible.alert) return null

  return (
    <div className="px-4 md:px-8 pt-4 space-y-2">
      {flash.notice && visible.notice && (
        <div
          className={cn(
            'flex items-center gap-3 rounded-lg border border-success/20 bg-success/5 px-4 py-2.5',
            'animate-in slide-in-from-top-2 duration-200'
          )}
        >
          <CheckCircleIcon className="h-4 w-4 text-success shrink-0" />
          <p className="flex-1 text-[13px] font-medium text-success">{flash.notice}</p>
          <button
            onClick={() => setVisible((v) => ({ ...v, notice: false }))}
            className="rounded p-0.5 text-success/60 hover:text-success transition-colors"
          >
            <XIcon className="h-3.5 w-3.5" />
          </button>
        </div>
      )}
      {flash.alert && visible.alert && (
        <div
          className={cn(
            'flex items-center gap-3 rounded-lg border border-destructive/20 bg-destructive/5 px-4 py-2.5',
            'animate-in slide-in-from-top-2 duration-200'
          )}
        >
          <AlertCircleIcon className="h-4 w-4 text-destructive shrink-0" />
          <p className="flex-1 text-[13px] font-medium text-destructive">{flash.alert}</p>
          <button
            onClick={() => setVisible((v) => ({ ...v, alert: false }))}
            className="rounded p-0.5 text-destructive/60 hover:text-destructive transition-colors"
          >
            <XIcon className="h-3.5 w-3.5" />
          </button>
        </div>
      )}
    </div>
  )
}
